import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { ErrorBoundary } from '../common/components/ErrorBoundary';
import { PostCard } from './PostCard';
import { PostRow } from './PostRow';
export const Post = ({ view = 'card', post, context, activeTagId = '', activeTagSlug = '', replyBar = true, collapsible = true, readonly, showContent, scrollObserver, ...rest }) => {
    const postRef = useRef(null);
    useEffect(() => {
        var _a;
        const element = postRef.current;
        if (scrollObserver && element) {
            element.id = (_a = post === null || post === void 0 ? void 0 : post.id) !== null && _a !== void 0 ? _a : '';
            scrollObserver.observe(element);
        }
        return () => {
            if (scrollObserver && element) {
                scrollObserver.unobserve(element);
            }
        };
    }, [post === null || post === void 0 ? void 0 : post.id, post === null || post === void 0 ? void 0 : post.title, scrollObserver]);
    if (view === 'row') {
        return (_jsx(ErrorBoundary, { children: _jsx(PostRow, { post: post, context: context }, void 0) }, void 0));
    }
    return (_jsx(ErrorBoundary, { children: _jsx(PostCard, { post: post, context: context, activeTagId: activeTagId, activeTagSlug: activeTagSlug, replyBar: replyBar, collapsible: collapsible, readonly: readonly, showContent: showContent, ref: postRef, ...rest }, void 0) }, void 0));
};
//# sourceMappingURL=Post.js.map